export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-800 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img
                src="https://public.readdy.ai/ai/img_res/0e861264-75ff-4390-8eda-552b537fd94f.png"
                alt="VeroTax Services"
                className="h-10 w-auto object-contain"
              />
              <div>
                <h3 className="font-bold text-lg">VeroTax Services</h3>
                <p className="text-xs text-gray-400">VeroTax Group LLC</p>
              </div>
            </div>
            <p className="text-gray-400 text-sm mb-4">
              Su socio de confianza en servicios profesionales de impuestos y documentación en Maryland.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-700 rounded-full hover:bg-teal-600 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-700 rounded-full hover:bg-teal-600 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-700 rounded-full hover:bg-teal-600 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-700 rounded-full hover:bg-teal-600 transition-colors cursor-pointer">
                <i className="ri-whatsapp-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-lg mb-4">Enlaces Rápidos</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection("home")} className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Inicio
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection("services")} className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Servicios
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection("why-choose-us")} className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Por Qué Elegirnos
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection("about")} className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Sobre Nosotros
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection("contact")} className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Contacto
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-bold text-lg mb-4">Servicios</h4>
            <ul className="space-y-2">
              <li className="text-gray-400 text-sm">Preparación de Impuestos</li>
              <li className="text-gray-400 text-sm">ITIN Aplicación</li>
              <li className="text-gray-400 text-sm">Licencia de Conducir MD</li>
              <li className="text-gray-400 text-sm">Notario Remoto</li>
              <li className="text-gray-400 text-sm">Servicios de Apostilla</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-bold text-lg mb-4">Contacto</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <i className="ri-phone-line text-teal-400 mt-1"></i>
                <a href="tel:+18556429085" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  (855) 642-9085
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-mail-line text-teal-400 mt-1"></i>
                <a href="mailto:info@verotaxgroupllc.com" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer break-all">
                  info@verotaxgroupllc.com
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-teal-400 mt-1"></i>
                <span className="text-gray-400 text-sm">
                  Maryland, Estados Unidos
                </span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-time-line text-teal-400 mt-1"></i>
                <span className="text-gray-400 text-sm">
                  Solo con cita previa
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-gray-400 text-sm text-center md:text-left">
            © 2025 VeroTax Services (VeroTax Group LLC). Todos los derechos reservados.
          </p>
          <div className="flex items-center space-x-6">
            <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer whitespace-nowrap">
              Política de Privacidad
            </a>
            <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer whitespace-nowrap">
              Términos de Servicio
            </a>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer whitespace-nowrap">
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
